import React from 'react';
import clock from 'assets/images/clock-blue.svg';
import calender from 'assets/images/calendar-blue.svg';

export const ListItems = (props) => {
  let transcationListData = props.list;
  let styles = props.styles;

  return (
    transcationListData &&
    transcationListData.map((items, index) => {
      if (index < 2) {
        return (
          <div className={styles.pageRight__item} key={index}>
            <p className={styles.idAmount}>
              <span className={styles.idAmount__id}>{items.Refno}</span>
              <span className={styles.idAmount__amount}>
                {items.CurrencyCode} {items.FCYAmt}
              </span>
            </p>
            <p className={styles.dateTime}>
              <span className={styles.dateTime__date}>
                <span>
                  <img src={calender} alt="" /> {items.Trandate.toString().split(' ')[0]}
                </span>
                <span>
                  <img src={clock} alt="" />
                  {items.Trandate.toString().split(' ')[1]}
                </span>
              </span>
              <span className={styles.dateTime__time}>@{items.MRate}</span>
            </p>
            <p className={styles.dateTime}>
              <span className={styles.dateTime__date}>{items.BenfName}</span>
              <span className={styles.dateTime__pending}>{items.Status}</span>
            </p>
          </div>
        );
      }
    })
  );
};
